import getOneIncMethodSpecificPaymentRequest from '../../OneInc/MethodSpecificPaymentRequest';

import getDefaultMethodSpecificPaymentRequest from './DefaultMethodSpecificPaymentRequest/DefaultMethodSpecificPaymentRequest';

const getMethodSpecificPaymentRequest = (paymentMethod) => {
  const getMethodSpecificPaymentRequest =
    paymentMethod === 'one_inc' ? getOneIncMethodSpecificPaymentRequest : getDefaultMethodSpecificPaymentRequest;
  const {
    methodSpecificInitialValues,
    methodSpecificValidationSchema,
    PaymentDetailsComponent,
    MethodDetailsComponent,
    additionalFinanceTableMenuOptions,
  } = getMethodSpecificPaymentRequest();

  return {
    methodSpecificInitialValues,
    methodSpecificValidationSchema,
    PaymentDetailsComponent,
    MethodDetailsComponent,
    additionalFinanceTableMenuOptions,
  };
};

export default getMethodSpecificPaymentRequest;
